import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const stats = [
    { key: 'sessions', strong: '1000+', rest: ' sessions tracked monthly' },
    { key: 'therapists', strong: '35', rest: ' therapists delivering verified sessions' },
    { key: 'dpdp', strong: '0 ', rest: 'payout disputes' },
    { key: 'platform', strong: 'DPDP-ready', rest: '' },
];

const ProofBar = () => {
    return (
        <Box
            component="section"
            aria-label="Platform proof points"
            sx={{
                width: '100%',
                borderTop: '1px solid rgba(0, 102, 255, 0.08)',
                borderBottom: '1px solid rgba(0, 102, 255, 0.08)',
                background: 'linear-gradient(90deg, #F8FAFF 0%, #FFFFFF 50%, #F8FAFF 100%)',
                py: { xs: 2, sm: 2.5, md: 3 },
            }}
        >
            <Container maxWidth="xl">
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        alignItems: 'stretch',
                        justifyContent: 'center',
                    }}
                >
                    {stats.map((stat, i) => (
                        <Box
                            key={stat.key}
                            sx={{
                                flex: { md: '1 1 0' },
                                minWidth: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                px: { xs: 2, sm: 3, md: 2 },
                                py: { xs: 1.5, md: 0 },
                                borderBottom: {
                                    xs: i < stats.length - 1 ? '1px solid rgba(15, 23, 42, 0.08)' : 'none',
                                    md: 'none',
                                },
                                borderRight: {
                                    xs: 'none',
                                    md: i < stats.length - 1 ? '1px solid rgba(15, 23, 42, 0.1)' : 'none',
                                },
                            }}
                        >
                            <Typography
                                component="p"
                                sx={{
                                    m: 0,
                                    fontSize: { xs: '0.8125rem', sm: '0.875rem', md: '0.9375rem' },
                                    lineHeight: 1.45,
                                    color: 'rgba(15, 23, 42, 0.82)',
                                    fontWeight: 500,
                                    letterSpacing: '-0.01em',
                                    maxWidth: { md: 240 },
                                    '& strong': {
                                        color: '#0F172A',
                                        fontWeight: 700,
                                    },
                                }}
                            >
                                <strong>{stat.strong}</strong>
                                {stat.rest}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Container>
        </Box>
    );
};

export default ProofBar;
